import React, {useState, useEffect}  from 'react';
import { NFTGrid } from './nftGrid';
import { transferNfts, transferOneCoach, transferOneRacer } from './helpers/racefunctions';
import { Modal } from 'bootstrap';


function CollList({collectionslist, transferFavs, transfersAllowed, transferAllAllowed, loadCollections, setModalInfo, walletAddress, weekInfo, accountDetails}){

    const [racersToTransfer, setRacersToTransfer] = useState([]);
    const [collections, setCollection] = useState([]);
    const [clearTransferChoice, setClearTransferChoice ] = useState(false);

    const clearTransfers = async() => {
        setClearTransferChoice(true);
        setRacersToTransfer([]);
        setClearTransferChoice(true);
    }

    useEffect(() => {
        setCollection(collectionslist);
    },[collectionslist])

    const transfer = async() => {
        let myNameModal = new Modal(document.getElementById('showAlerts'));

        if (transferAllAllowed){
        let tos = [];
        let ids = [];
        let contracts = [];

        for (let x = 0; x < racersToTransfer.length; x++){
            tos.push(racersToTransfer[x].transferto);
            ids.push(racersToTransfer[x].id);
            contracts.push(racersToTransfer[x].contract);
            
        }

        
		setModalInfo({"message":'Waiting on transfer wallet approval.',"type":'transfernft'})
		myNameModal.show();
		const updateResp = await transferNfts(tos,ids,contracts);
		if (updateResp !== undefined){
			if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
				
				setModalInfo({"message":"NFTs transfered successfully.", "type":"nftstransfered" });
			//	setTransferAllAllowed(e.target.checked);
			await loadCollections(0, false,0);
            setRacersToTransfer([]);
			}else {
				setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
				return false;
			}
		 } else {
				setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
				return false;
		 }
        }else{
        
		setModalInfo({"message":'Waiting on transfer wallet approval.',"type":'transfernft'})
		myNameModal.show();
        let updateResp;
            for (let x = 0; x < racersToTransfer.length; x++){
                updateResp = await transferOneRacer(walletAddress, racersToTransfer[x].transferto, racersToTransfer[x].id);
		if (updateResp !== undefined){
			if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
				

			}else {
				setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
				return false;
			}
		 } else {
				setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
				return false;
		 }

            }
            await loadCollections(0, false,0);
            setRacersToTransfer([]);
            setModalInfo({"message":"NFTs transfered successfully.", "type":"nftstransfered" });
        }
    }


    return <div><div className='createFormat row' ><div className='col-md-4' style={{fontWeight:'bold'}}>Collection:</div><div className='col'>Show / Hide</div><div className='col'><button id="tranferbutton" className='btn btn-primary' style={{display:(racersToTransfer.length > 0 ? 'unset' : 'none')}} onClick={() => transfer()}>Transfer</button><button id="tranferbutton" className='btn btn-primary' style={{display:(racersToTransfer.length > 0 ? 'unset' : 'none'), marginLeft:'10px'}} onClick={() => clearTransfers()}>Clear </button></div></div>{collections.map( function(coll, i) {
       return <div key={i} id={'coll' + i.toString()} className='createFormat row'><div className='col-md-4' >{coll.collection} ({coll.racercount})</div><NFTGrid nftArray={coll.racers} nftType={coll.collection} transferFavs={transferFavs} transfersAllowed={transfersAllowed} racersToTransfer={racersToTransfer} setRacersToTransfer={setRacersToTransfer} clearTransferChoice={clearTransferChoice} weekInfo={weekInfo} accountDetails={accountDetails} /> </div>
        
    })}</div>
}

export {CollList};